import { getFormattedDate } from '@lib/utils/dateTimeHelpers';
import { dateFormatForApi } from '@lib/enums/dateTime';
import { DateRangeInputObject } from 'graphql-common';

export default function getPeriodInput(
  period: string[] | undefined,
): DateRangeInputObject | null {
  const startDate = period?.[0];
  const endDate = period?.[1];
  if (!startDate || !endDate) return null;
  // `period` bounds are CET-anchored ISO datetimes (see
  // `getDefaultAnalyticsPeriod`/`DateRangePicker`'s `transformDate` output);
  // the API expects bare `yyyy-MM-dd` dates.
  return {
    startDate: getFormattedDate(startDate, dateFormatForApi) || startDate,
    endDate: getFormattedDate(endDate, dateFormatForApi) || endDate,
  };
}
